import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import {
  loginAsync,
  logout as logoutAction,
  clearError as clearErrorAction,
} from '@/store/slices/authSlice.ts';
import type { LC_AuthenticateIn } from '../auth.types';


export function useAuth() {
  const dispatch = useAppDispatch();
  const auth = useAppSelector(state => state.auth);
  const login = useCallback(
    (credentials: LC_AuthenticateIn) =>
      dispatch(loginAsync(credentials)).unwrap(),
    [dispatch],
  );
  const logout = useCallback(() => {
    dispatch(logoutAction());
  }, [dispatch]);
  const clearError = useCallback(() => {
    dispatch(clearErrorAction());
  }, [dispatch]);
  return { ...auth, login, logout, clearError };
}
